import { LabelValue } from '../../model';

export const compareLabelValueObjectsEquality = (object1: LabelValue, object2: LabelValue): boolean => {
  return object1.value === object2.value && object1.label === object2.label;
};
